module.exports = __webpack_public_path__ + "img/zlgl.55798310.svg";